import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * ChangePasswordView class for handling password change functionality.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the UI components for the change password view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section for new password input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'NewPassword', // Input field for new password
                    type: 'password',
                    label: _('Nueva Contraseña'), // Label for new password
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for required field
                },
            ],
        };

        // Right section for confirm password input
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'ConfirmPassword', // Input field for confirming password
                    type: 'password',
                    label: _('Confirmar Contraseña'), // Label for confirm password
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for required field
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Upper section containing the password input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [
                        center_left, // New password section
                        right, // Confirm password section
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Guardar'), // Save button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        var vthis = this; // Reference to the current instance
                        if (this.getRoot().validate()) {
                            // Validate form fields
                            const newPassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            if (
                                newPassword.NewPassword === newPassword.ConfirmPassword // Check if passwords match
                            ) {
                                const data = {
                                    ClientId: cur_user, // Client ID for the request
                                    Password: newPassword.NewPassword, // New password
                                    ConfirmPassword: newPassword.ConfirmPassword, // Confirm password
                                };
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type for the request
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Client/ResetPassword', // API endpoint for password reset
                                        data,
                                        {
                                            error: function (text, data, XmlHttpRequest) {}, // Error handling (empty)
                                            success: function (text, data, XmlHttpRequest) {
                                                var json = JSON.parse(text); // Parse response JSON
                                                if (json.HasError) {
                                                    webix.message('Error'); // Show error message
                                                } else {
                                                    vthis.getRoot().clear(); // Clear form on success
                                                    webix.message(
                                                        _('Guardado'), // Show success message
                                                    );
                                                }
                                            },
                                        },
                                    );
                            } else {
                                webix.message({
                                    title: '¡Error!', // Error title
                                    type: 'alert-error', // Error type
                                    text: _('Contraseñas no coinciden'), // Error message for password mismatch
                                });
                            }
                        } else {
                            webix.message({
                                title: '¡Error!', // Error title
                                type: 'alert-error', // Error type
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                        }
                    },
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formChangePassword', // ID for the form
            rows: [upper_section, buttons], // Form layout
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validate fields on change
                    },
                },
            },
        };
    }
}

// FILE DOCUMENTED
